import { Container } from '../../../components/Container'
import { Section } from '../../../components/Section'
import { Steps } from '../../../components/Steps'
import { StepsContent } from '../../../context/StepsContext'
import { InsuranceInfo } from '../../../containers/InsuranceInfo'
import { OfferCestovkoCompare } from '../../../containers/offers/OfferCestovkoCompare'
import { SignalRProvider } from 'brokertslib/src/context/SignalRProvider';
import { CestovkoOffersProvider } from '../../../context/CestovkoOffersProvider'
import { WithAuth } from '../../../containers/hoc/WithAuth'
import WizardForbiddenMessage from '../../../components/WizardForbiddenMessage'
import { useContext } from 'react'
import { insuranceParamsContext } from '../../../layouts/Wizard'
import { Loading } from '../../../components/Loading'

const baseUrl = process.env.PUBLIC_URL
const hubUrl = process.env.REACT_APP_CALCULATION_HUB
const url = `${baseUrl}/${hubUrl}`

const _Step3 = () => {
  const { insuranceParams, insuranceParamsId: paramsId, isLoadingData } = useContext(insuranceParamsContext)

  return (
    <Section>
      <Container>
        {isLoadingData && <Loading large={true} />}

        {(!paramsId || insuranceParams) && !isLoadingData &&
          <StepsContent step={3}>
            <SignalRProvider url={url}>
              <CestovkoOffersProvider>
                <Steps icon="beach" />

                <InsuranceInfo />

                <OfferCestovkoCompare />
              </CestovkoOffersProvider>
            </SignalRProvider>
          </StepsContent>
        }

        <WizardForbiddenMessage />
      </Container>
    </Section>
  )
}

export const Step3 = WithAuth(_Step3)